import { render, staticRenderFns } from "./cultimanage.vue?vue&type=template&id=5228835b&scoped=true&"
import script from "./cultimanage.vue?vue&type=script&lang=js&"
export * from "./cultimanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228835b",
  null
  
)

export default component.exports